<div class="full-column" [class.hidden]="environment.siteTitle !== 'Dimers' || articleLoading || articleError || !['MLB', 'CFB'].includes(article?.tags?.[0]?.slug | uppercase)">
	<div class="ad-container">
		<div class="desktop-banner">
			<div id="a6285c83-b252-46c8-8845-dc8f0f316a83"></div>
		</div>
		<div class="mobile-banner">
			<div id="e6979b4e-f640-4bf4-b348-c08bf3d71986"></div>
		</div>
	</div>
</div>
<div class="main-column">
	<div class="article-loading" *ngIf="articleLoading && !articleError">
		Loading...
	</div>
	<div class="article-loading" *ngIf="articleError">
		<span>
			Sorry, something went wrong loading this article. Please <span class="retry-link" (click)="loadArticleData()">try again</span>.
		</span>
		
	</div>
	<article *ngIf="!articleLoading && !articleError">
		<app-hub-nav-header
			*ngIf="article.tags?.[0]"
			currentRoute="article"
			[sportCode]="article.tags[0].slug"
		></app-hub-nav-header>
		<div class="article-header">
			<h1 class="article-title" [textContent]="article.title"></h1>
			<span class="article-date" *ngIf="formattedUpdatedDate">
				<span>Last updated: {{ formattedUpdatedDate }}</span> | <span>Published: {{ formattedDate }}</span>
			</span>
			<span class="article-date" *ngIf="!formattedUpdatedDate">
				{{ formattedDate }}
			</span>
		</div>
		<app-article-image-container class="article-hero" imageSrc="{{ article.thumbnail.dynamic_url }}?w=750" [lazy]="false">
		</app-article-image-container>
		<div class="author-share-line">
			<span class="article-author">
				By
				<span *ngIf="article.authors?.length">
					<span *ngFor="let author of article.authors; last as last">
						<a class="author-link" routerLink="/news/author/{{ author.slug }}">
							{{ author.first_name }} {{ author.last_name }}
						</a>
						{{ !last ? ', ' : '' }}
					</span>
				</span>
				<span *ngIf="!article.authors?.length">
					{{ article.author }}
				</span>
			</span>

			<div class="share-buttons">
				<span class="share-title">Share</span>
				<a class="bsts-box email socialite"
					href="mailto:?subject=I%20found%20this%20webpage&amp;body=Hi,%20I%20found%20this%20webpage%20and%20thought%20you%20might%20like%20it%20{{ environment.canonicalDomain }}/news/{{ slug }}"
					data-platform="email" data-track-type="click" data-index="5" data-component="Social links" data-count="5" rel="noopener">
					<fa-icon [icon]="faEnvelope" aria-label="Share via Email"></fa-icon>
				</a>
				<a class="bsts-box twitter socialite"
					href="https://twitter.com/intent/tweet?text={{ article.title }}&amp;url={{ environment.canonicalDomain }}/news/{{ slug }}"
					data-platform="twitter" target="_blank" data-action="tweet" data-track-type="click" data-index="2"
					data-component="Social links" data-count="5" rel="noopener">
					<fa-icon [icon]="faTwitter" aria-label="Share on Twitter"></fa-icon>
				</a>
				<a class="bsts-box facebook socialite"
					href="https://www.facebook.com/sharer/sharer.php?u={{ environment.canonicalDomain }}/news/{{ slug }}"
					data-platform="facebook" target="_blank" data-action="share" data-track-type="click" data-index="1"
					data-component="Social links" data-count="5" rel="noopener">
					<fa-icon [icon]="faFacebookF" aria-label="Share on Facebook"></fa-icon>
				</a>
				<a class="bsts-box generic socialite"
					(click)="openShareDialog()"
					data-platform="generic" data-action="share" data-track-type="click" data-index="1"
					data-component="Social links" data-count="5" rel="noopener">
					<fa-icon [icon]="faShare" aria-label="Share..."></fa-icon>
				</a>
			</div>
		</div>
		<app-article-body [content]="trustedContent" [articleID]="article.id"></app-article-body>
		<div class="share-buttons at-foot">
			<span class="share-title">Share</span>
			<a class="bsts-box email socialite"
				href="mailto:?subject=I%20found%20this%20webpage&amp;body=Hi,%20I%20found%20this%20webpage%20and%20thought%20you%20might%20like%20it%20{{ environment.canonicalDomain }}/news/{{ slug }}"
				data-platform="email" data-track-type="click" data-index="5" data-component="Social links" data-count="5" rel="noopener">
				<fa-icon [icon]="faEnvelope" aria-label="Share via Email"></fa-icon>
			</a>
			<a class="bsts-box twitter socialite"
				href="https://twitter.com/intent/tweet?text={{ article.title }}&amp;url={{ environment.canonicalDomain }}/news/{{ slug }}"
				data-platform="twitter" target="_blank" data-action="tweet" data-track-type="click" data-index="2"
				data-component="Social links" data-count="5" rel="noopener">
				<fa-icon [icon]="faTwitter" aria-label="Share on Twitter"></fa-icon>
			</a>
			<a class="bsts-box facebook socialite"
				href="https://www.facebook.com/sharer/sharer.php?u={{ environment.canonicalDomain }}/news/{{ slug }}"
				data-platform="facebook" target="_blank" data-action="share" data-track-type="click" data-index="1"
				data-component="Social links" data-count="5" rel="noopener">
				<fa-icon [icon]="faFacebookF" aria-label="Share on Facebook"></fa-icon>
			</a>
			<a class="bsts-box generic socialite"
				(click)="openShareDialog()"
				data-platform="generic" data-action="share" data-track-type="click" data-index="1"
				data-component="Social links" data-count="5" rel="noopener">
				<fa-icon [icon]="faShare" aria-label="Share..."></fa-icon>
			</a>
		</div>
		<ng-container *ngIf="article.authors?.length">
			<div class="author-profile" *ngFor="let author of article.authors">
				<div class="author-image" *ngIf="author.thumbnail">
					<picture *ngIf="author.thumbnail?.dynamic_url">
						<source [srcset]="author.thumbnail.dynamic_url + '?w=200&fm=webp'" type="image/webp">
						<source [srcset]="author.thumbnail.dynamic_url + '?w=200'" type="image/jpeg">
						<img alt=""
							[src]="author.thumbnail.dynamic_url + '?w=200'" class="book-image" loading="lazy">
					</picture>
				</div>
				<div class="author-text">
					<a class="author-name" routerLink="/news/author/{{ author.slug }}">{{ author.first_name }} {{ author.last_name }}</a>
					<div class="author-bio" [innerHtml]="author.description"></div>
				</div>
			</div>
		</ng-container>
		
	</article>

	<!-- <disqus *ngIf="!articleLoading && !articleError" [identifier]="article.slug" url="{{ environment.canonicalDomain }}/{{ article.slug }}"></disqus> -->

	<app-related-articles-row
		*ngIf="!articleLoading && !articleError && article.tags?.[0] && !environment.optionalFeatures.includes('taboola')"
		[sportCode]="article.tags[0].slug"
		[exceptID]="article.id"
	></app-related-articles-row>
	
	<app-best-offers *ngIf="!articleLoading && !articleError && environment.optionalFeatures.includes('best-offers')" [sportCode]="article.tags?.[0]?.slug || undefined"></app-best-offers>

	<app-taboola-section *ngIf="environment.optionalFeatures.includes('taboola')"></app-taboola-section>
</div>
<div class="sidebar">
    <ng-container *ngIf="!articleLoading && !articleError && article.tags?.[0]?.slug ==='RACING' && environment.siteTitle === 'Stats Insider'; else upcoming">
        <app-display-ad type="articles-POS1" class="large-only" [largeOnly]="true" *ngIf="environment.googleAdsConfig?.adSpaces?.['articles-POS1'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
		<app-latest-articles-list sportCode="racing"></app-latest-articles-list>
    </ng-container>
    <ng-template #upcoming>
        <app-upcoming-matches-list
            *ngIf="environment.availableSports.length > 0 && !articleLoading && !articleError && article.tags?.[0] && inSeasonSport(article.tags[0].slug)"
            [sportCode]="article.tags[0].slug"></app-upcoming-matches-list>
		<app-display-ad type="articles-POS1" class="large-only" [largeOnly]="true" *ngIf="environment.googleAdsConfig?.adSpaces?.['articles-POS1'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
	
    </ng-template>

	<app-book-offers *ngIf="environment.optionalFeatures.includes('welcome-offers')"></app-book-offers>
    <app-legal-betting *ngIf="environment.optionalFeatures.includes('legal-betting-sidebar')"></app-legal-betting>
	<app-radar-link *ngIf="environment.siteTitle === 'Radar Sports'"></app-radar-link>
	<!-- <app-how-we-make-money *ngIf="environment.optionalFeatures.includes('best-books')"></app-how-we-make-money> -->
    <app-newsletter-signup-prompt *ngIf="environment.optionalFeatures.includes('newsletter')"></app-newsletter-signup-prompt>
	<app-display-ad type="sidebar-multi" *ngIf="(environment.googleAdsConfig?.adSpaces?.['sidebar-multi'] || environment.optionalFeatures.includes('placeholder-ads')) && !articleLoading && !articleError && article.tags?.[0]" [sportCode]="article.tags?.[0]?.slug || undefined"></app-display-ad>
	<app-futures-snapshot *ngIf="!articleLoading && !articleError && environment.availableSports.length > 0 &&  article?.tags?.[0]?.slug !== 'RACING'" [sportCode]="article?.tags?.[0]?.slug || undefined"></app-futures-snapshot>
	<app-display-ad type="articles-POS2" class="large-only sticky" [largeOnly]="true" *ngIf="environment.googleAdsConfig?.adSpaces?.['articles-POS2'] || environment.optionalFeatures.includes('placeholder-ads')"></app-display-ad>
	<app-odds-disclaimer *ngIf="environment.optionalFeatures.includes('odds-disclaimer')"></app-odds-disclaimer>
</div>
<app-adhesive-banner *ngIf="environment.optionalFeatures.includes('adhesive-banner')"></app-adhesive-banner>
<!-- <app-subscribe-scroll-prompt *ngIf="environment.optionalFeatures.includes('newsletter') && environment.newsletterProvider === 'surge'"></app-subscribe-scroll-prompt> -->
